class State {
    
    constructor() {
        this.preferences = {}
        this.currentStep = 1
    }

    addPreferences(step, preferences) {
        this.preferences[step] = preferences
        this.currentStep = step+1
    }

}

var state = new State()
export default state
